var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "popup",
      staticClass: "app-dialer-keypad-popup",
      style: _vm.componentStyle,
      attrs: { "data-popup": "" },
    },
    [
      _c("app-dialer-keypad", {
        attrs: { dial: _vm.dial, "is-disabled": _vm.isDisabled },
        on: { "key-click": _vm.onKeyClick },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "actions", attrs: { "data-popup": "" } }, [
        _c(
          "div",
          {
            staticClass: "icon-button",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_c("or-icon", { attrs: { icon: "close" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icon-button", on: { click: _vm.onBackspaceClick } },
          [_c("or-icon", { attrs: { icon: "backspace" } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }